import * as types from "../constants/actionTypes";

export const searchprovidersInitialState = {
    providers: [],
    providerData: [],
    success: false,
    searchRunning: false,
    error: false,
    specialties: [],
    languages: [],
    ageGroups: [],
    visitTypes: [],
    providerDetails: [],
    updateFacets: false,
    searchModel: null,
    usesMyBSWHealth: null,
    detailsPending: false,
    earliestScheduleSuccess: false,
    earliestScheduleWaiting: false,
    earliestScheduleError: false,
    earliestScheduleProvider: null,
    isSlotAvailable: null,
    isSlotAvailableUnderRadius: null,
    searchForVaxSlotAvailRunning: false,
    searchForVaxSlotAvailSuccess: false,
    searchForVaxSlotAvailError: false,
    earliestDirectVVSchedule: null,
    providerListByVisitTypeSuccess: false,
    providerListByVisitTypeWaiting: false,
    providerListByVisitTypeError: false


};

export default function searchProvidersReducer(state = searchprovidersInitialState, action) {
    switch (action.type) {

        case types.UPDATE_FACETS:
            return { ...state, updateFacets: action.updateFacets };
        case types.SEARCH_PROVIDER_CLEAR:
            return { ...state, clearSearch: true, success: false, providers: [], totalProviders: 0 };
        case types.SEARCH_PROVIDER:
            return { ...state, clearSearch: false, searchModel: action.searchModel, success: true, searchRunning: true, error: false };
        case types.PROVIDER_DETAIL:
            return { ...state, success: true, searchRunning: true, error: false, detailsPending: true };
        case types.LOAD_PROVIDERS_SUCCESS:

            // phynd service returned a 200 with a null response...
            if (action === null || action.providers === null) {
                return {
                    ...state,
                    providers: [],
                    specialties: [],
                    languages: [],
                    ageGroups: [],
                    visitTypes: [],
                    providerDetails: [],
                    smartResponseResults: null,
                    success: false,
                    searchRunning: false,
                    error: false
                };
            }
            else {
                // successful response.
                return {
                    ...state, providers: action.providers.providerResults,
                    totalProviders: action.providers.totalProviders,
                    success: true,
                    searchRunning: false,
                    error: false,
                    specialties: action && action.providers.aggregation && action.providers.aggregation.specialtyfacet ? action.providers.aggregation.specialtyfacet.items : state.specialties,
                    languages: state.updateFacets === true && action && action.providers.aggregation && action.providers.aggregation.languagesfacet ? action.providers.aggregation.languagesfacet.items : state.languages,
                    ageGroups: state.updateFacets === true && action && action.providers.aggregation && action.providers.aggregation.patientAgeGroupfacet ? action.providers.aggregation.patientAgeGroupfacet.items : state.ageGroups,
                    visitTypes: state.updateFacets === true && action && action.providers.aggregation && action.providers.aggregation.visitTypefacet ? action.providers.aggregation.visitTypefacet.items : state.visitTypes,
                    updateFacets: false,
                    appliedRules: action && action.providers && action.providers.appliedRules ? action.providers.appliedRules : [],
                    smartResponseResults: action.providers.smartResponseResults.newProviderCount > 0 ? action.providers.smartResponseResults : null
                };
            }
        case types.LOAD_PROVIDER_DETAIL_SUCCESS:
            const results = action.providers.length > 0 ? action.providers : null;
            return { ...state, providerDetails: results, success: true, searchRunning: false, error: false, detailsPending: false };
        case types.CLEAR_PROVIDERS:
            return {
                ...state, providers: [], providerDetails: [], totalProviders: 0, specialties: [], languages: [],
                ageGroups: [], visitTypes: [], success: true, searchRunning: false, error: false, detailsPending: false,
            };
        case types.CLEAR_PROVIDER_DETAIL:
            return {
                ...state, providerDetails: [], detailsPending: false
            };
        case types.SEARCH_PROVIDER_ERROR:
            return { ...state, success: false, searchRunning: false, error: true, detailsPending: false };
        case types.SAVE_PROVIDER_SEARCH_MODEL:
            return {
                ...state, searchModel: action && action.payload && action.payload.searchModel ? action.payload.searchModel : null
            };
        case types.LOGOUT:
            return searchprovidersInitialState;
        case types.UPDATE_USEMYBSWHEALTH_FILTER:
            return {
                ...state, usesMyBSWHealth: action.usesMyBSWHealth
            };
        case types.FIND_CARE_FILTERS_OPEN:
            return { ...state, findCareFiltersOpen: action.isOpen };
        case types.GET_PROVIDER_WITH_EARLIESTSCHEDULE:
            return { ...state, earliestScheduleSearchModel: action.searchModel, earliestScheduleSuccess: true, earliestScheduleWaiting: true, earliestScheduleError: false };

        case types.GET_PROVIDERS_LIST_VISITTYPE:
            return { ...state, providerListByVisitTypeSuccess: false, providerListByVisitTypeWaiting: true, providerListByVisitTypeError: false };
        case types.GET_PROVIDERS_LIST_VISITTYPE_SUCCESS:
            return { ...state, providerData: action.providers, providerListByVisitTypeSuccess: true, providerListByVisitTypeWaiting: false, providerListByVisitTypeError: false };
        case types.GET_PROVIDERS_LIST_VISITTYPE_FAILURE:
            return { ...state, providerData: action.providers, providerListByVisitTypeSuccess: false, providerListByVisitTypeWaiting: false, providerListByVisitTypeError: true };
        case types.GET_PROVIDERS_LIST_VISITTYPE_PENDING:
            return { ...state, providerData: action.providers, providerListByVisitTypeSuccess: false, providerListByVisitTypeWaiting: true, providerListByVisitTypeError: true };

        case types.GET_PROVIDERS_LIST_BY_VISITTYPE:
            return { ...state, earliestScheduleSuccess: false, earliestScheduleWaiting: true, earliestScheduleError: false };
        case types.GET_PROVIDER_WITH_EARLIESTSCHEDULE_SUCCESS:

            // phynd service returned a 200 with a null response...
            if (action === null || action.providers === null) {
                return {
                    ...state,
                    earliestScheduleSuccess: false,
                    earliestScheduleWaiting: false,
                    earliestScheduleError: false,
                    earliestScheduleProvider: null
                };
            }
            else {
                // successful response.
                return {
                    ...state, 
                    earliestScheduleProvider: action.providers,
                    earliestScheduleSuccess: true,
                    earliestScheduleWaiting: false,
                    earliestScheduleError: false
                };
            }
        case types.GET_PROVIDER_WITH_EARLIESTSCHEDULE_ERROR:
            return { ...state, earliestScheduleSuccess: false, earliestScheduleWaiting: false, earliestScheduleError: true };

        case types.SEARCH_FOR_GENERIC_PROVIDER:
            return { ...state, clearSearch: false, searchModel: action.searchModel, success: true, searchRunning: true, error: false };
        case types.SEARCH_FOR_GENERIC_PROVIDER_SUCCESS:
            {
                // phynd service returned a 200 with a null response...
                if (action === null || action.providers === null) {
                    return {
                        ...state,
                        providers: [],
                        specialties: [],
                        languages: [],
                        ageGroups: [],
                        visitTypes: [],
                        providerDetails: [],
                        success: false,
                        searchRunning: false,
                        error: false
                    };
                }
                else {
                    // successful response.                            
                    return {
                        ...state,
                        providers: action.providers.providerResults,
                        totalProviders: action.providers.totalProviders,
                        success: true,
                        searchRunning: false,
                        error: false,
                        specialties: state.updateFacets === true && action && action.providers.aggregation && action.providers.aggregation.specialtyfacet ? action.providers.aggregation.specialtyfacet.items : state.specialties,
                        languages: state.updateFacets === true && action && action.providers.aggregation && action.providers.aggregation.languagesfacet ? action.providers.aggregation.languagesfacet.items : state.languages,
                        ageGroups: state.updateFacets === true && action && action.providers.aggregation && action.providers.aggregation.patientAgeGroupfacet ? action.providers.aggregation.patientAgeGroupfacet.items : state.ageGroups,
                        visitTypes: state.updateFacets === true && action && action.providers.aggregation && action.providers.aggregation.visitTypefacet ? action.providers.aggregation.visitTypefacet.items : state.visitTypes,
                        updateFacets: false,
                        appliedRules: action && action.providers && action.providers.appliedRules ? action.providers.appliedRules : []
                    };
                }
            }
        case types.SEARCH_FOR_GENERIC_PROVIDER_FAILURE:
            return { ...state, success: false, searchRunning: false, error: true, detailsPending: false };
        case types.SEARCH_FOR_GENERIC_PROVIDER_SLOT_AVAILABILITY:
            return { ...state, searchForVaxSlotAvailRunning: true, searchForVaxSlotAvailSuccess: false, searchForVaxSlotAvailError: false, isSlotAvailable: null, isSlotAvailableUnderRadius: null };
        case types.SEARCH_FOR_GENERIC_PROVIDER_SLOT_AVAILABILITY_SUCCESS:
            {
                // phynd service returned a 200 with a null response...
                if (action === null || action.providers === null) {
                    return {
                        ...state,
                        searchForVaxSlotAvailSuccess: false,
                        searchForVaxSlotAvailRunning: false,
                        searchForVaxSlotAvailError: false,
                        isSlotAvailable: false,
                        isSlotAvailableUnderRadius: false
                    };
                }
                else {
                    // successful response.
                    let isSlotAvailable = false;
                    let isSlotAvailableUnderRadius = false;
                    const vaccineSearchRadius = window.serverData && window.serverData.data ? window.serverData.data.CovidVaccineSearchRadius : 25;
                    if (action.providers && action.providers.providerResults && action.providers.providerResults.length > 0) {
                        for (let prov = 0; prov < action.providers.providerResults.length; prov++) {
                            const providerObj = action.providers.providerResults[prov];
                            if (providerObj && providerObj.provider && providerObj.provider.locations) {
                                for (let loc = 0; loc < providerObj.provider.locations.length; loc++) {
                                    const locObj = providerObj.provider.locations[loc];
                                    if (locObj && typeof locObj.distance !== 'undefined' && locObj.distance !== null && locObj.distance !== '' &&
                                        vaccineSearchRadius >= locObj.distance) {
                                        isSlotAvailableUnderRadius = true;
                                    }
                                    if (locObj.openSchedules && locObj.openSchedules.dateAndTimes && locObj.openSchedules.dateAndTimes.length > 0) {
                                        isSlotAvailable = true;
                                    }
                                    if (isSlotAvailable && isSlotAvailableUnderRadius) break;
                                }
                            }
                            if (isSlotAvailable && isSlotAvailableUnderRadius) break;
                        }
                    }

                    return {
                        ...state,
                        searchForVaxSlotAvailSuccess: true,
                        searchForVaxSlotAvailRunning: false,
                        searchForVaxSlotAvailError: false,
                        isSlotAvailable: isSlotAvailable,
                        isSlotAvailableUnderRadius: isSlotAvailableUnderRadius
                    };
                }
            }
        case types.SEARCH_FOR_GENERIC_PROVIDER_SLOT_AVAILABILITY_FAILURE:
            return { ...state, searchForVaxSlotAvailSuccess: false, searchForVaxSlotAvailRunning: false, searchForVaxSlotAvailError: true, isSlotAvailable: false, isSlotAvailableUnderRadius: false };

        default:
            return { ...state };
    }
}